import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { Alarm } from '../../../@core/domain/interfaces/alarm.interface';
import { AlarmsApiService } from '../../../@core/api/alarms-api.service';

/**
 * Bell icon for emergency alarm status
 */
@Component({
  selector: 'app-alarm-bell',
  templateUrl: './alarm-bell.component.html',
  styleUrls: ['./alarm-bell.component.scss'],
})
export class AlarmBellComponent implements OnInit, OnDestroy {
  color = '#f9430e';
  size = 6;
  radius = 4;

  obs!: Subscription;

  alarms$!: Observable<Alarm[]>;
  alarmGoing = false;

  constructor(private alarmsApiService: AlarmsApiService) {}

  ngOnInit(): void {
    this.alarms$ = this.alarmsApiService.alarms;
    this.alarmsApiService.loadDivisionsEmergencyAlarms();

    const status = [];
    this.obs = this.alarms$.subscribe((alarms) => {
      if (alarms) {
        alarms.forEach((a) => {
          if (a.enabled && a.going) {
            status.push(a);
          }
        });
        if (status.length > 0) {
          this.alarmGoing = true;
        }
      } else {
        this.alarmGoing = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.obs.unsubscribe();
    this.alarmGoing = false;
  }
}
